import {Component, OnInit, ViewChild} from '@angular/core';
import {CdkDrag, CdkDragDrop, CdkDropList, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {ExcTranslation} from 'exc-core-v2';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {ExcRestService} from 'exc-rest-v2';
import {ExgApplicationEventEmitter} from '../classes/ExgApplicationEventEmitter';
import {ExgEventArgs} from '../classes/ExgEventArgs';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Component({
  selector: 'app-exg-photo-documentation',
  templateUrl: './exg-photo-documentation.component.html',
  styles: []
})
export class ExgPhotoDocumentationComponent extends ExcTranslation implements OnInit {
  @ViewChild('AttachementList', {read: ExgDataListComponent}) AttList!: ExgDataListComponent;

  /*if not Upload its Edit*/
  isNewPhotoDocMode = true;
  isLoadingInitEdit = true;
  Data: any = {
    FKID: '',
    pdData: '',
    pdName: '',
    pdDescription: '',
    pdPhotoDocumentationStatus_enmIdent: this.enumSvc.getEnumerationDefaultValue('DokTyp'),
    pdUPT: '',
    aueSchadenNr: ''
  };
  uiUploadModel = {
    dokTrackingPortalShare: false,
    dokDescription: '',
    dokSize: 0,
    dokName: '',
    dok_objID: '',
    dokMIME: '',
    dokbIMG: '',
    dok_enmIdent_DokTyp: this.enumSvc.getEnumerationDefaultValue('DokTyp'),
    dokEigenschaft: [] as any[],
  };
  dokEigenschaftHelper: any = {};
  Events = new ExgApplicationEventEmitter();
  pages: {
    layout: number;
    top: { dokID: string; comment: string; [key: string]: any }[];
    left: { dokID: string; comment: string; [key: string]: any }[];
    right: { dokID: string; comment: string; [key: string]: any }[];
    bottom: { dokID: string; comment: string; [key: string]: any }[];
    [key: string]: any;
  }[] = [{layout: 4, top: [], left: [], right: [], bottom: []}];
  tabinstance: any;
  isLoadingTab = true;
  allPagesFull = false;
  private savedPhotoDocState = '';
  connectedListsId = ['piclist'];
  private nextPageDropListID = 0;
  picbox: any = {
    data: [] as any[],
    delIncludedData: [] as any[],
    state: 0,
    searchValue: '',
    selectedRow: {},
    allPDFPagesMode: false,
    isSearching: false,
    hideOriginals: true,
    selected: [] as any[],
    selectionChanged: (index: number) => {
      this.picbox.selectedRow = this.picbox.data[index];
    },
    search: (value: string) => {
      if (value && value !== '') {
        this.picbox.searchValue = value;
        this.picbox.loadData();
      } else {
        this.picbox.searchValue = '';
        this.picbox.loadData();
      }
    },
    loadData: () => {
      const SELF = this;
      const hideOriginals = this.picbox.hideOriginals ? 1 : 0;
      if (this.picbox.state !== 1) {
        SELF.picbox.state = 1;
        this.excRest.get(this.excRest.computeUrl('DocumentR_List_PhotoDoc'
          , {objID: this.Data.FKID,
                  hideOriginals,
                  fts: this.picbox.searchValue})).subscribe((response: any) => {
          if (response.success) {
            this.picbox.delIncludedData = response.data.documents;
            this.picbox.data = this.removeDeletedAndUsedData(response.data.documents);
            this.sortPicboxData();
            this.picbox.ready();
          }
          else {
            this.modal.showToast('Dokumente konnten nicht geladen werden.', 'md-toast', 'fal fa-exclamation');
            this.picbox.ready();
          }
        });
      }
    },
    loadDataObs: (): Observable<any> => {
      this.picbox.state = 1;
      const hideOriginals = this.picbox.hideOriginals ? 1 : 0;
      return this.excRest.get(this.excRest.computeUrl('DocumentR_List_PhotoDoc', {
        objID: this.Data.FKID,
        hideOriginals,
        fts: this.picbox.searchValue
      })).pipe(
        tap((response: any) => {
          if (response.success) {
            this.picbox.delIncludedData = response.data.documents;
            this.picbox.data = this.removeDeletedAndUsedData(response.data.documents);
            this.sortPicboxData();
            this.picbox.ready();
          } else {
            this.modal.showToast('Dokumente konnten nicht geladen werden.', 'md-toast', 'fal fa-exclamation');
            this.picbox.ready();
          }
        })
      );
    },
    ready: () => {
      if (!this.picbox.data || this.picbox.data.length === 0) {
        this.picbox.state = 2;

        if (this.AttList) {
          this.AttList.selectedRow = -1;
        }
      } else {
        this.picbox.state = 0;

        if (this.AttList) {
          this.AttList.selectedRow = 0;
        }
      }
    },
    showAttachmentPreview: (dokID?: string): void => {
      this.appSvc.Document.Preview.OpenModal({objID: this.Data?.FKID, attID: dokID}, {Events: this.Events});
    },
    toggleShowAllMedia: (): void => {
      if (this.picbox.state !== 1) {
        this.picbox.hideOriginals = !this.picbox.hideOriginals;
        this.picbox.loadData();
      }
    }
  };
  private dokIDEditedImage = '';
  private dokIDResetImage = '';
  private selectedPageEditedImage = 1;
  private selectedPageResetImage = 1;
  private dokInImageEditor: any;

  constructor(
    public excRest: ExcRestService,
    public modal: ExgModalService,
    public excSecurity: ExcSecurityService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService) {
    super();
  }

  ngOnInit(): void {
    if (this.tabinstance && this.Data.pdName) {
      this.tabinstance.Label = this.Data.pdName;
    } else {
      this.tabinstance.Label = this.getRessource('Label');
    }
    this.setConnectedListsID();
    this.initialLoad();
    this.registerEvents();
  }
  /*Init Methods*/
  registerEvents(): void {
    this.Events?.Document?.UploadDialog?.Closed?.subscribe((evt: ExgEventArgs) => {
      this.picbox.loadData();
    });
    this.Events?.Document?.UploadSaveAsNewDialog?.Closed?.subscribe( (ret: any) => {
      if ( ret?.success?.success && ret?.success?.data[0]?.dokID) {
        this.picbox.loadDataObs().subscribe((ret2: any) => {
          if (ret2.success) {
            this.onImageEditComplete(ret.success.data[0].dokID, this.dokIDEditedImage, this.selectedPageEditedImage);
            this.picbox.loadData();
          }
        });
      }
      else {
        this.modal.showToast('Bearbeitung fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
      }
    });
    /*Upload/Download Photodoc*/
    this.Events?.Document?.UploadSaveEditDialog?.Closed?.subscribe((ret: any) => {
      if (ret?.success?.data[0]?.dokID){
        this.onImageEditFileComplete(ret.success.data[0].dokID);
        this.picbox.loadData();
      }
    });
    this.Events?.Document?.PreviewDialog?.Closed?.subscribe( (ret: any) => {
      if (ret?.success) {
        this.picbox.loadData();
        this.modal.showToast('Bearbeitung erfolgreich', 'md-toast', 'fas fa-check');
      }
    });
    this.Events?.PhotoDocumentation?.Download?.Finished?.subscribe( (ret: any) => {
      if (ret?.success) {
        this.isLoadingTab = false;
        this.modal.showToast('Download erfolgreich', 'md-toast', 'fas fa-check');
      }
      else {
        this.modal.showToast('Download fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
      }
    });
    this.Events?.PhotoDocumentation?.PreviewModal?.Success?.subscribe( (ret: any) => {
      this.isLoadingTab = false;
    });
    this.Events?.ImageEditor?.OpenModal?.ClosedSave?.subscribe((ret: any) => {
      if (ret?.success && ret?.data?.save) {
        const dokTyp = ret.data.dok_enmIdent_DokTyp;
        const dokID = ret.data.dokID;
        const formData = ret.data.save;
        formData.set(
          'DataObject',
          JSON.stringify({
            dok_enmIdent_DokTyp: dokTyp,
            dokIsEdited: true,
          })
        );
        this.appSvc.Document.Upload.SaveEditRequest({ dokID }, formData, {Events: this.Events});
      }
    });
    this.Events?.ImageEditor?.OpenModal?.ClosedSaveAs?.subscribe((ret: any) => {
      if (ret?.success && ret?.data?.saveAsNew) {
        const dokTyp = ret.data.dok_enmIdent_DokTyp;
        this.dokIDEditedImage = ret.data.dokID;
        this.selectedPageEditedImage = ret.data.selectedPage;
        const formData = ret.data.saveAsNew;
        formData.set(
          'DataObject',
          JSON.stringify({
            dok_enmIdent_DokTyp: dokTyp,
            dokBeschreibung: this.uiUploadModel.dokDescription,
            dokTrackingPortalShare: this.uiUploadModel.dokTrackingPortalShare,
            DokEigenschaft: this.uiUploadModel.dokEigenschaft,
            dokIsEdited: true,
            dokParentID: this.dokInImageEditor.dokID
          })
        );
        this.appSvc.Document.Upload.SaveAsNewRequest({ dok_objID: this.Data.FKID}, formData, {Events: this.Events});
      }
    });
    this.Events?.ImageEditor?.OpenModal?.ClosedReset?.subscribe((ret: any) => {
      if (ret?.success && ret?.data?.reset) {
        setTimeout( () => {
          this.modal.showSimple('Bearbeitung zurücksetzen?'
          , 'Wollen Sie die Bearbeitung wirklich zurücksetzen? Dies hat keine Auswirkungen auf bestehende Bilddokumentationen. In der aktiven Bilddokumentation wird das bearbeitete Bild durch das Original ersetzt.'
          , true, true
          , 'Zurücksetzen', 'Abbrechen').subscribe((confirm: any) => {
          if (confirm) {
            this.dokIDResetImage = ret.data.dokID;
            this.selectedPageResetImage = ret.data.selectedPage;
            this.appSvc.Document.DokEdit.ResetEditRequest({ dokID: this.dokIDResetImage}, {Events: this.Events});
          }
        });
      }, 50);
      }
    });
    this.Events?.Document.ResetEditDialog.Closed?.subscribe((ret: any) => {
      if (ret.success && ret.data) { // wenn delete erfolgreich
        this.picbox.loadDataObs().subscribe((ret2: any) => { // lade Liste mit Original neu
          if (ret2.success) { // Wenn erfolgreich replace das zurückgesetzte mit dem Original
            this.onImageEditComplete(ret.data.data.Document.dokParentID, ret.data.data.Document.dokID, this.selectedPageResetImage);
          }
        });
      }
    });
  }
  private initialLoad(): void {
    const SELF = this;
    SELF.picbox.state = 1;
    const hideOriginals =
      this.Data?.pdData
        ? 0
        : (this.picbox.hideOriginals ? 1 : 0);
    this.excRest.get(this.excRest.computeUrl('DocumentR_List_PhotoDoc'
      , {objID: this.Data.FKID, fts: this.picbox.searchValue, hideOriginals})).subscribe((response: any) => {
      if (response?.success && response.data?.documents) {
        this.picbox.delIncludedData = response.data.documents;
        if (this.Data?.pdData) {
          this.openPagesFromInput();
        }
        else {
          this.rememberPhotoDocState();
          this.isLoadingTab = false;
          this.isLoadingInitEdit = false;
          this.refreshConnectedListsAfterRender();
        }
        const documents = this.picbox.hideOriginals
          ? response.data.documents.filter((doc: any) => !doc.dokHasEdit)
          : response.data.documents;
        this.picbox.data = this.removeDeletedAndUsedData(documents);
        this.sortPicboxData();
        this.picbox.ready();
      }
      else {
        this.modal.showToast('Dokumente konnten nicht geladen werden.', 'md-toast', 'fal fa-exclamation');
        this.isLoadingTab = false;
        this.isLoadingInitEdit = false;
        this.picbox.ready();
      }
    });
  }
  private openPagesFromInput(): void {
    this.isNewPhotoDocMode = false;
    const pdDataObj = this.deepCopy(JSON.parse(this.Data.pdData));
    this.reverseTransformPagesContainerFromInput(pdDataObj.pages);
  }
  /*Helper Methods*/
  deepCopy(item: any): any {
    // Primitive Werte oder null/unbekannte Typen direkt zurückgeben
    if (item === null || typeof item !== 'object') {
      return item;
    }
    // Array-Fall: Rekursive Kopie für jedes Element im Array
    if (Array.isArray(item)) {
      const arrayCopy: any[] = [];
      for (const element of item) {
        arrayCopy.push(this.deepCopy(element));
      }
      return arrayCopy;
    }
    // Objekt-Fall: Rekursive Kopie für jedes Property im Objekt
    const objectCopy: { [key: string]: any } = {};
    for (const key in item) {
      if (item.hasOwnProperty(key)) {
        objectCopy[key] = this.deepCopy(item[key]);
      }
    }
    return objectCopy;
  }
  computeImageUrl(item: any): string {
    return this.excRest.computeUrl('ImageThumbnailBig', { dokID: item.dokID });
  }
  computePageImageUrl(item: any): string {
    return this.excRest.computeUrl('ImageThumbnailBig', { dokID: item.dokID, page: item.selectedPage - 1 });
  }
  private sortPicboxData(): void {
    this.picbox.data.sort((a: any, b: any) => {
      return Number(a.dok_enmIdent_DokTyp) - Number(b.dok_enmIdent_DokTyp);
    });
  }
  getPicboxFolderCount(row: any): number {
    return this.picbox.data.filter((item: any) =>
      !item.dokDEL &&
      item.dok_enmIdent_DokTyp === row.dok_enmIdent_DokTyp
    ).length;
  }
  getBoxMaxPicCount(page: any, boxToDropTo: string): number {
    if (page.layout === 1 && boxToDropTo === 'top') {
      return 1;
    } else if (page.layout === 2 && (boxToDropTo === 'top' || boxToDropTo === 'bottom')) {
      return 1;
    } else if (page.layout === 4 && (boxToDropTo === 'left' || boxToDropTo === 'right')) {
      return 2;
    } else {
      return 0;
    }
  }
  getFileType(row: any): string {
    return row.dokErw?.replace('.', '').toUpperCase() || '';
  }
  get canSavePhotoDoc(): boolean {
    if (this.isLoadingTab || !this.hasPhotoDocImages()) {
      return false;
    }
    if (this.isNewPhotoDocMode) {
      return true;
    }
    return this.getCurrentPhotoDocState() !== this.savedPhotoDocState;
  }
  private hasPhotoDocImages(): boolean {
    return this.pages.some(page =>
      page.top.length > 0 ||
      page.left.length > 0 ||
      page.right.length > 0 ||
      page.bottom.length > 0
    );
  }
  private getNonEmptyPages(): any[] {
    return this.pages.filter(page =>
      page.top.length > 0 ||
      page.left.length > 0 ||
      page.right.length > 0 ||
      page.bottom.length > 0
    );
  }
  private getCurrentPhotoDocState(): string {
    return JSON.stringify(
      this.transformPagesContainer(this.getNonEmptyPages())
    );
  }
  private rememberPhotoDocState(): void {
    this.savedPhotoDocState = this.getCurrentPhotoDocState();
  }
  private applySavedPages(savedPages: any[]): void {
    this.reverseTransformPagesContainerFromInput(savedPages);
    this.picbox.loadData();
  }
  /*Pages UI Methods*/
  removePage(page: any): void {
    this.picbox.loadData();
    this.pages.splice(this.pages.indexOf(page), 1);
    // Indizes der zu löschenden Elemente sammeln
    const indicesToDelete: number[] = [];
    this.picbox.data.forEach((obj: { selectedPage: number; [p: string]: any }, index: any) => {
      if (obj.selectedPage > 0) {
        indicesToDelete.push(index);
      }
    });
    for (let i = indicesToDelete.length - 1; i >= 0; i--) {
      this.picbox.data.splice(indicesToDelete[i], 1);
    }
    this.allPagesFull = this.checkIfPagesFull();
    this.refreshConnectedListsAfterRender();
  }
  changePageTemplate(
    page: any,
    chosenlayout: number
  ): void {
    const pageIndex = this.pages.indexOf(page);
    this.pages[pageIndex].layout =
      chosenlayout;
    const pics = [
      ...page.top,
      ...page.left,
      ...page.right,
      ...page.bottom
    ];
    this.distributePicsToNewTemplate(
      pics,
      page,
      chosenlayout
    );
    this.refreshConnectedListsAfterRender();
  }
  changePicComment(item: { dokID: string; [p: string]: any }): void {
    if (item) {
      this.modal.show('ModalChangeImageCommentComponent', item).subscribe((result) => {
        if (result?.comment) {
          item.comment = result.comment;
          this.modal.showToast('Bildunterschrift geändert', 'md-toast', 'fal fa-check');
        }
        else if (result?.comment === '' ) {
          item.comment = result.comment;
          this.modal.showToast('Bildunterschrift entfernt', 'md-toast', 'fal fa-check');
        }
      });
    }
  }
  changeHeaderOrFooter(isHeader: boolean = true, pageIndex: number, comment: string = ''): void {
    this.modal.show('ModalChangeHeaderFooterComponent'
      , { isHeader, comment }
    ).subscribe((rslt: any) => {
      if (rslt && (rslt.comment || rslt.comment === '')) {
        if (isHeader) {
          this.pages[pageIndex].header = rslt.comment;
          const toastText = rslt.comment === '' ? 'Kopfzeile entfernt' : 'Kopfzeile geändert';
          this.modal.showToast( toastText, 'md-toast', 'fal fa-check');
        }
        else {
          this.pages[pageIndex].footer = rslt.comment;
          const toastText = rslt.comment === '' ? 'Fußzeile entfernt' : 'Fußzeile geändert';
          this.modal.showToast( toastText, 'md-toast', 'fal fa-check');
        }
      }
    });
  }
  /*Sidebar Methods*/
  addPage(): void {
    this.pages.push({layout: 4, top: [], left: [], right: [], bottom: []});
    this.allPagesFull = false;
    this.refreshConnectedListsAfterRender();
  }
  togglePDFPagesMode(): void {
    this.picbox.allPDFPagesMode =
      !this.picbox.allPDFPagesMode;
  }
  showAttachmentUploadModal(): void {
    this.appSvc.Document.Upload.OpenModal({dok_objID: this.Data?.FKID},
      {Events: this.Events});
  }
  downloadPDF(): void {
    const pdDataObj = {
      fkID: this.Data.FKID,
      pages: this.transformPagesContainer(this.pages)};
    const editModel = { pdName: this.Data.pdName};
    if (!this.Data.pdName && this.Data.aueSchadenNr) {
      editModel.pdName = this.Data.aueSchadenNr  + '_Bilddokumentation';
    }
    this.modal.show('ModalFinishPhotoDocComponent', {isUpload: true, isOnlyDownload: true, editModel})
      .subscribe( (rslt: any) => {
      if (rslt) {
        const createModel = {
          pdData: JSON.stringify(pdDataObj),
          pdName: rslt.pdName, // nvarChar 256
          pdDescription: rslt.pdDescription, // nvarchar 2048
          pdPhotoDocumentationStatus_enmIdent: rslt.pdPhotoDocumentationStatus_enmIdent
        };
        const url = this.excRest.computeUrl('PhotoDocumentation_Download', {});
        this.isLoadingTab = true;
        this.excRest.post(url, createModel, {export: true})
          .subscribe((ret: any) => {
            if (ret?.success) {
              this.isLoadingTab = false;
            }
            else {
              this.modal.showToast('Zusammenführung fehlgeschlagen', 'md-toast', 'fas fa-exclamation');
              this.isLoadingTab = false;
            }
          });
      }
    });
  }
  previewPDF(): void {
    const pdDataObj = {
      fkID: this.Data.FKID,
      pages: this.transformPagesContainer(this.pages)};
    const createModel = {
      pdData: JSON.stringify(pdDataObj),
      pdName: this.Data.aueSchadenNr + '_Bilddokumentation', // nvarChar 256
      pdDescription: '', // nvarchar 2048
      pdPhotoDocumentationStatus_enmIdent: this.enumSvc.getEnumerationDefaultValue('DokTyp'),
      pdIsPreview: true
    };
    this.isLoadingTab = true;
    this.appSvc.PhotoDocumentation.PreviewModal({...createModel, ...{ FKID: this.Data.FKID }}, {Events: this.Events});
  }
  /*Drag and Drop*/
  dropPage(event: CdkDragDrop<{ layout: number;
    top: { dokID: string; comment: string; [p: string]: any }[];
    left: { dokID: string; comment: string; [p: string]: any }[];
    right: { dokID: string; comment: string; [p: string]: any }[];
    bottom: { dokID: string; comment: string; [p: string]: any }[]; [p: string]: any }[], any>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }
  }
  dropPictureOnLeft(event: CdkDragDrop<{ dokID: string; comment: string; [p: string]: any }[], any>
                  , page: { layout: number;
                              top: { dokID: string; comment: string; [p: string]: any }[];
                              left: { dokID: string; comment: string; [p: string]: any }[];
                              right: { dokID: string; comment: string; [p: string]: any }[];
                              bottom: { dokID: string; comment: string; [p: string]: any }[]; [p: string]: any }): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      /*Moved Item is multipage*/
      if (event.item.data.dokPages && event.item.data.dokPages > 1 && !event.item.data.selectedPage) {
        this.openMultiPagesModal(event, page);
      }
      /*Moved Item is single page -> move it*/
      else {

        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
        );

        /*if from right, piclist, then copy, else transfer between pages */
        /*if (event.previousContainer.id === 'piclist') {
          const previousData = event.previousContainer.data[event.previousIndex];
          const deepCopiedItem = this.deepCopy(previousData);
          deepCopiedItem.imageVisible = true;
          // Insert the deep copied item into the target container's data array
          event.container.data.splice(event.currentIndex, 0, deepCopiedItem);
        } else {
          transferArrayItem(
            event.previousContainer.data,
            event.container.data,
            event.previousIndex,
            event.currentIndex,
          );
        }*/
      }
    }
    this.allPagesFull = this.checkIfPagesFull();
  }
  dropPictureOnRight(event: CdkDragDrop<{ dokID: string; comment: string; selectedPage?: number; [p: string]: any }[], any>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      // Item löschen
      // event.previousContainer.data.splice(event.previousIndex, 1);
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    }
    this.sortPicboxData();
    this.allPagesFull = this.checkIfPagesFull();
  }
  isPicDropAvailable(
    drag: CdkDrag,
    dropList: CdkDropList,
    page: any,
    boxToDropTo: string
  ): boolean {
    const maxPics =
      this.getBoxMaxPicCount(
        page,
        boxToDropTo
      );

    return !!dropList.data &&
      dropList.data.length < maxPics;
  }
  isPicDropAvailableWrapper(
    page: any,
    boxToDropTo: string
  ): any {
    return (
      drag: CdkDrag,
      dropList: CdkDropList
    ) => {
      return this.isPicDropAvailable(
        drag,
        dropList,
        page,
        boxToDropTo
      );
    };
  }
  private createPageDropListID(): string {
    const id =
      'photodoc-page-' + this.nextPageDropListID;
    this.nextPageDropListID++;
    return id;
  }
  private ensurePageDropListIDs(): void {
    const usedIDs = new Set<string>();
    for (const page of this.pages) {
      if (
        !page.dropListID ||
        usedIDs.has(page.dropListID)
      ) {
        page.dropListID =
          this.createPageDropListID();
      }
      usedIDs.add(page.dropListID);
    }
  }
  setConnectedListsID(): void {
    this.ensurePageDropListIDs();
    const connectedIDs = ['piclist'];
    this.pages.forEach(page => {
      if (page.layout === 1) {
        connectedIDs.push(
          page.dropListID + '-top'
        );
      } else if (page.layout === 2) {
        connectedIDs.push(
          page.dropListID + '-top'
        );
        connectedIDs.push(
          page.dropListID + '-bottom'
        );
      } else if (page.layout === 4) {
        connectedIDs.push(
          page.dropListID + '-left'
        );
        connectedIDs.push(
          page.dropListID + '-right'
        );
      }
    });
    this.connectedListsId = connectedIDs;
  }
  private refreshConnectedListsAfterRender(): void {
    this.setConnectedListsID();
    setTimeout(() => {
      this.setConnectedListsID();
    });
  }
  private distributePicsToNewTemplate(pics: any[], page: any, chosenlayout: number): void {
    if (pics && pics.length > 0 && page && chosenlayout) {
      /*Mache Model für neue Zuweisung*/
      const picModel = {
        top: [] as any[],
        left: [] as any[],
        right: [] as any[],
        bottom: [] as any[]
      };

      const boxOrder = ['top', 'left', 'right', 'bottom'] as const;
      let currentBoxIndex = 0;
      /*Iteriere über zu verteilende Bilder*/
      for (let i = 0; i < pics.length;) {
        const pic = pics[i];
        let added = false;
        /*solange die Box nicht voll ist wird pic aus picbox reingeschoben*/
        while (currentBoxIndex < boxOrder.length) {
          const currentBox = boxOrder[currentBoxIndex];
          const maxPicCount = this.getBoxMaxPicCount(page, currentBox);

          if (picModel[currentBox].length < maxPicCount) {
            picModel[currentBox].push(pic);
            pics.splice(i, 1);
            added = true;
            break;
            /*Ansonsten geh zur nächsten Box*/
          } else {
            currentBoxIndex++;
          }
        }
        if (!added) {
          // Wenn das Bild nicht einer Box hinzugefügt wurde sind alle Boxen voll, beende Schleife
          i = pics.length;
        }
      }
      /*Model an Page anpassen + Zu viele Pics zurück in die Source*/
      page.top = picModel.top;
      page.left = picModel.left;
      page.right = picModel.right;
      page.bottom = picModel.bottom;
      if (pics.length > 0) {
        const pageIndex = this.pages.indexOf(page);
        const p = JSON.parse(JSON.stringify(page));
        const template = [4, 2, 1].findIndex(e => e >= pics.length);
        p.layout = [4, 2, 1][template];
        this.pages.splice(pageIndex + 1, 0, p);

        this.distributePicsToNewTemplate(pics, p, [4, 2, 1][template]);
      }
      // this.Data.source = [...this.Data.source, ...pics];
      this.allPagesFull = this.checkIfPagesFull();
      this.refreshConnectedListsAfterRender();
    }
  }
  private checkIfPagesFull(): boolean {
    let fullPicCount = 0;
    let actualPicCount = 0;
    this.pages.forEach((page) => {
      fullPicCount += page.layout;
      actualPicCount += [...page.top, ...page.left, ...page.right, ...page.bottom].length;
    });
    return fullPicCount === actualPicCount && fullPicCount !== 0;
  }
  private getPagePositionOrder(
    page: any
  ): string[] {
    if (page.layout === 1) {
      return ['top'];
    }
    if (page.layout === 2) {
      return ['top', 'bottom'];
    }
    if (page.layout === 4) {
      return ['left', 'right'];
    }
    return [];
  }
  private getDroppedPagePosition(
    page: any,
    targetData: any[]
  ): string {
    const positions =
      this.getPagePositionOrder(page);
    const position = positions.find(
      item => page[item] === targetData
    );
    return position || '';
  }
  private fillPageWithPDFPages(
    page: any,
    pagesToInsert: any[],
    preferredPosition: string = '',
    preferredIndex?: number
  ): void {
    const normalPositions =
      this.getPagePositionOrder(page);
    const positions = preferredPosition
      ? [
        preferredPosition,
        ...normalPositions.filter(
          position =>
            position !== preferredPosition
        )
      ]
      : normalPositions;
    let firstInsertion = true;
    for (const position of positions) {
      const targetArray = page[position];
      const maxPicCount =
        this.getBoxMaxPicCount(
          page,
          position
        );
      while (
        pagesToInsert.length > 0 &&
        targetArray.length < maxPicCount
        ) {
        const item = pagesToInsert.shift();
        if (
          firstInsertion &&
          position === preferredPosition
        ) {
          const insertIndex = Math.min(
            Math.max(
              preferredIndex !== undefined
                ? preferredIndex
                : targetArray.length,
              0
            ),
            targetArray.length
          );
          targetArray.splice(
            insertIndex,
            0,
            item
          );
          firstInsertion = false;
        } else {
          targetArray.push(item);
        }
      }
    }
  }
  private distributePDFPagesFromDrop(
    event: CdkDragDrop<any[], any>,
    targetPage: any,
    selectedPages: any[]
  ): void {
    if (
      !selectedPages ||
      selectedPages.length === 0
    ) {
      return;
    }
    const targetPosition =
      this.getDroppedPagePosition(
        targetPage,
        event.container.data
      );
    if (!targetPosition) {
      return;
    }
    const pagesToInsert = selectedPages.map(
      item => ({
        ...item,
        imageVisible: true
      })
    );
    this.fillPageWithPDFPages(
      targetPage,
      pagesToInsert,
      targetPosition,
      event.currentIndex
    );
    let newPageIndex =
      this.pages.indexOf(targetPage) + 1;
    while (pagesToInsert.length > 0) {
      const newPage = {
        layout: targetPage.layout,
        top: [],
        left: [],
        right: [],
        bottom: []
      };
      this.fillPageWithPDFPages(
        newPage,
        pagesToInsert
      );
      this.pages.splice(
        newPageIndex,
        0,
        newPage
      );
      newPageIndex++;
    }
    this.removeUsedDocumentFromPicbox(
      event.item.data.dokID
    );
    this.allPagesFull =
      this.checkIfPagesFull();
    this.refreshConnectedListsAfterRender();
  }
  private openMultiPagesModal(event: CdkDragDrop<{ dokID: string; comment: string; [p: string]: any }[], any>
                            , page: { layout: number;
                            top: { dokID: string; comment: string; [p: string]: any }[];
                            left: { dokID: string; comment: string; [p: string]: any }[];
                            right: { dokID: string; comment: string; [p: string]: any }[];
                            bottom: { dokID: string; comment: string; [p: string]: any }[]; [p: string]: any }): void {
    if (event.item.data && event.item.data.dokPages > 1) {
      /*Alle Seiten Modus*/
       if (this.picbox.allPDFPagesMode) {
         this.allPagesModePageDrop(page, event);
       }
       /*Selektierte Seiten Modus*/
       else {
         this.selectPagesForPageDrop(event, page);
       }
    }
  }
  private selectPagesForPageDrop(event: CdkDragDrop<{ dokID: string; comment: string; [p: string]: any }[], any>,
                                 page: { layout: number;
                                   top: { dokID: string; comment: string; [p: string]: any }[];
                                   left: { dokID: string; comment: string; [p: string]: any }[];
                                   right: { dokID: string; comment: string; [p: string]: any }[];
                                   bottom: { dokID: string; comment: string; [p: string]: any }[]; [p: string]: any }): void {
    this.modal.show('ModalPickPageOfPDFComponent', {page: event.item.data}).subscribe((selectionRslt: any) => {
      if (selectionRslt?.selectedPages?.length > 0) {
        this.distributePDFPagesFromDrop(event, page, selectionRslt.selectedPages);
      }
    });
  }
  private allPagesModePageDrop(page: { layout: number;
                                 top: { dokID: string; comment: string; [p: string]: any }[];
                                 left: { dokID: string; comment: string; [p: string]: any }[];
                                 right: { dokID: string; comment: string; [p: string]: any }[];
                                 bottom: { dokID: string; comment: string; [p: string]: any }[]; [p: string]: any },
                               event: CdkDragDrop<{ dokID: string; comment: string; [p: string]: any }[], any>): void {
    const selectedPages: any[] = [];
    for (let pageNumber = 1; pageNumber <= event.item.data.dokPages; pageNumber++) {
      selectedPages.push({...event.item.data, selectedPage: pageNumber});
    }
    this.distributePDFPagesFromDrop(event, page, selectedPages);
  }
  /*Saving Methods*/
  pressedSave(): void {
    if (!this.canSavePhotoDoc) {
      return;
    }
    const pagesToSave = this.getNonEmptyPages();
    const pdDataObj = {
      fkID: this.Data.FKID,
      pages: this.transformPagesContainer(pagesToSave)
    };
    if (this.isNewPhotoDocMode) {
      const editModel = {
        pdName: this.Data.pdName,
        pdDescription: this.Data.pdDescription,
        pdPhotoDocumentationStatus_enmIdent:
        this.Data.pdPhotoDocumentationStatus_enmIdent
      };
      if (!editModel.pdName && this.Data.aueSchadenNr) {
        editModel.pdName =
          this.Data.aueSchadenNr + '_Bilddokumentation';
      }
      this.modal.show(
        'ModalFinishPhotoDocComponent',
        {
          isUpload: true,
          editModel
        }
      ).subscribe((rslt: any) => {
        if (rslt?.action === 'save') {
          this.createPhotoDocumentation(
            pdDataObj,
            pagesToSave,
            rslt
          );
        }
      });
      return;
    }
    this.updatePhotoDocumentation(
      pdDataObj,
      pagesToSave,
      {
        pdName: this.Data.pdName,
        pdDescription: this.Data.pdDescription,
        pdPhotoDocumentationStatus_enmIdent:
        this.Data.pdPhotoDocumentationStatus_enmIdent
      }
    );
  }
  openPhotoDocDetails(): void {
    if (this.isNewPhotoDocMode) {
      return;
    }
    this.modal.show(
      'ModalFinishPhotoDocComponent',
      {
        isUpload: false,
        editModel: this.Data
      }
    ).subscribe((rslt: any) => {
      if (!rslt) {
        return;
      }
      if (rslt.del) {
        setTimeout(() => {
          this.deletePhotoDocumentation(rslt.pdID, rslt.pdUPT);
        }, 50);

        return;
      }
      const pagesToSave = this.getNonEmptyPages();
      const pdDataObj = {
        fkID: this.Data.FKID,
        pages: this.transformPagesContainer(pagesToSave)
      };
      if (rslt.action === 'saveAs') {
        this.createPhotoDocumentation(
          pdDataObj,
          pagesToSave,
          rslt
        );
      } else if (rslt.action === 'save') {
        this.updatePhotoDocumentation(
          pdDataObj,
          pagesToSave,
          rslt
        );
      }
    });
  }
  private deletePhotoDocumentation(pdID: string, pdUPT: string): void {
    if (!pdID || !pdUPT) {
      this.modal.showToast(
        'Bilddokumentation konnte nicht gelöscht werden',
        'md-toast',
        'fas fa-exclamation'
      );
      return;
    }
    this.modal.showSimple(
      'Bilddokumentation löschen',
      'Möchten Sie die Bilddokumentation wirklich löschen?',
      true,
      true,
      this.getGlobal('Delete'),
      this.getGlobal('Cancel')
    ).subscribe((confirmed: boolean) => {
      if (!confirmed) {
        return;
      }
      const url = this.excRest.computeUrl(
        'PhotoDocumentationD',
        {pdID}
      );
      this.isLoadingTab = true;
      this.excRest.delete(
        url,
        {pdUPT}
      ).subscribe(
        (ret: any) => {
          this.isLoadingTab = false;
          if (ret?.success) {
            this.modal.showToast(
              'Bilddokumentation gelöscht',
              'md-toast',
              'fas fa-check'
            );
            this.refreshParentSummary();
            if (typeof this.tabinstance?.Close === 'function') {
              this.tabinstance.Close();
            }
          } else {
            this.modal.showToast(
              'Bilddokumentation konnte nicht gelöscht werden',
              'md-toast',
              'fas fa-exclamation'
            );
          }
        },
        () => {
          this.isLoadingTab = false;
          this.modal.showToast(
            'Bilddokumentation konnte nicht gelöscht werden',
            'md-toast',
            'fas fa-exclamation'
          );
        }
      );
    });
  }
  private refreshParentSummary(): void {
    this.Data?.Events?.Document?.UpdateDialog?.Closed?.emit({
      success: true
    });
  }
  private updatePhotoDocumentation(
    pdDataObj: any,
    pagesToSave: any[],
    editModel: any
  ): void {
    const updateModel = {
      pdData: JSON.stringify(pdDataObj),
      pdName: editModel.pdName,
      pdDescription: editModel.pdDescription,
      pdPhotoDocumentationStatus_enmIdent:
      editModel.pdPhotoDocumentationStatus_enmIdent,
      pdUPT: this.Data.pdUPT
    };
    const url = this.excRest.computeUrl(
      'PhotoDocumentationU',
      {pdID: this.Data.pdID}
    );
    this.isLoadingTab = true;
    this.excRest.put(url, updateModel)
      .subscribe((ret: any) => {
        if (
          ret?.success &&
          ret?.data?.[0]?.pdID &&
          ret.data[0].pdUPT
        ) {
          const savedPhotoDoc = ret.data[0];
          this.Data.pdData = JSON.stringify(pdDataObj);
          this.Data.pdName =
            savedPhotoDoc.pdName || editModel.pdName;
          this.Data.pdDescription =
            savedPhotoDoc.pdDescription ??
            editModel.pdDescription;
          this.Data.pdPhotoDocumentationStatus_enmIdent =
            savedPhotoDoc.pdPhotoDocumentationStatus_enmIdent ??
            editModel.pdPhotoDocumentationStatus_enmIdent;
          this.Data.pdUPT = savedPhotoDoc.pdUPT;
          this.applySavedPages(pdDataObj.pages);
          this.tabinstance.Label = this.Data.pdName;
          this.isLoadingTab = false;
          this.refreshParentSummary();
          this.modal.showToast(
            'Bilddokumentation gespeichert',
            'md-toast',
            'fas fa-check'
          );
        } else {
          this.modal.showToast(
            'Zusammenführung fehlgeschlagen',
            'md-toast',
            'fas fa-exclamation'
          );
          this.isLoadingTab = false;
        }
      });
  }
  private createPhotoDocumentation(
    pdDataObj: any,
    pagesToSave: any[],
    editModel: any
  ): void {
    const createModel = {
      pdData: JSON.stringify(pdDataObj),
      pdName: editModel.pdName,
      pdDescription: editModel.pdDescription,
      pdPhotoDocumentationStatus_enmIdent:
      editModel.pdPhotoDocumentationStatus_enmIdent
    };
    const url = this.excRest.computeUrl(
      'PhotoDocumentationC',
      {FKID: this.Data.FKID}
    );
    this.isLoadingTab = true;
    this.excRest.post(url, createModel)
      .subscribe((ret: any) => {
        if (
          ret?.success &&
          ret?.data?.PhotoDocumentation?.pdID
        ) {
          const createdPhotoDoc =
            ret.data.PhotoDocumentation;
          this.Data.pdID = createdPhotoDoc.pdID;
          this.Data.pdUPT =
            createdPhotoDoc.pdUPT || this.Data.pdUPT;
          this.Data.pdData = JSON.stringify(pdDataObj);
          this.Data.pdName =
            createdPhotoDoc.pdName || createModel.pdName;
          this.Data.pdDescription =
            createdPhotoDoc.pdDescription ??
            createModel.pdDescription;
          this.Data.pdPhotoDocumentationStatus_enmIdent =
            createdPhotoDoc.pdPhotoDocumentationStatus_enmIdent ??
            createModel.pdPhotoDocumentationStatus_enmIdent;
          this.isNewPhotoDocMode = false;
          this.applySavedPages(pdDataObj.pages);
          this.tabinstance.Label = this.Data.pdName;
          this.isLoadingTab = false;
          this.refreshParentSummary();
          this.modal.showToast(
            'Bilddokumentation gespeichert',
            'md-toast',
            'fas fa-check'
          );
        } else {
          this.modal.showToast(
            'Zusammenführung fehlgeschlagen',
            'md-toast',
            'fas fa-exclamation'
          );
          this.isLoadingTab = false;
        }
      });
  }
  private transformPageImages(items: any[], startSlot?: number): any[] {
    return items.map((item: any, index: number) => {
      const image: any = {
        dokID: item.dokID,
        page: item.selectedPage || 1,
        subtitle: item.comment || ''
      };
      if (startSlot !== undefined) {
        image.slot = startSlot + index;
      }
      return image;
    });
  }
  private transformPagesContainer(pages: {
    layout: number;
    top: { dokID: string; comment: string; selectedPage?: number; [key: string]: any }[];
    left: { dokID: string; comment: string; selectedPage?: number; [key: string]: any }[];
    right: { dokID: string; comment: string; selectedPage?: number; [key: string]: any }[];
    bottom: { dokID: string; comment: string; selectedPage?: number; [key: string]: any }[];
    [key: string]: any
  }[]): any {
    return pages.map(page => {
      let images: any[] = [];
      if (page.layout === 1) {
        images = this.transformPageImages(page.top);
      } else if (page.layout === 2) {
        images = [
          ...this.transformPageImages(page.top),
          ...this.transformPageImages(page.bottom)
        ];
      } else if (page.layout === 4) {
        images = [
          ...this.transformPageImages(page.left, 1),
          ...this.transformPageImages(page.right, 3)
        ];
      }
      return {
        layout: page.layout,
        images
      };
    });
  }
  private reverseTransformPagesContainerFromInput(pages: {
    layout: number;
    images: { dokID: string; page: number; subtitle: string; slot?: number }[];
  }[]): void {
    this.pages = pages.map(item => {
      const images = item.images;
      const page: any = { layout: item.layout, top: [], left: [], right: [], bottom: [] };

      switch (item.layout) {
        case 1:
          images.forEach(image => {
            this.createAndPushImageObject(image, page.top);
          });
          break;
        case 2:
          if (images.length >= 1) {
            this.createAndPushImageObject(images[0], page.top);
          }
          if (images.length >= 2) {
            this.createAndPushImageObject(images[1], page.bottom);
          }
          break;
        case 4:
          images.forEach((image, index) => {
            const slot = image.slot || index + 1;
            this.createAndPushImageObject(image, slot > 2 ? page.right : page.left);
          });
          break;
      }
      return page;
    });
    this.allPagesFull = this.checkIfPagesFull();
    this.rememberPhotoDocState();
    this.isLoadingInitEdit = false;
    this.isLoadingTab = false;
    this.refreshConnectedListsAfterRender();
  }
  private createAndPushImageObject(image: { dokID: string; page: number; subtitle: string; slot?: number }, targetArray: any[]): void {
    const ogDokObjIndex = this.picbox.delIncludedData.map((a: any) => a.dokID).indexOf(image.dokID);
    const ogDokObj = this.deepCopy(this.picbox.delIncludedData[ogDokObjIndex]);
    ogDokObj.selectedPage = image.page;
    ogDokObj.comment = image.subtitle;
    ogDokObj.imageVisible = true;
    targetArray.push(ogDokObj);
  }
  /*ImageEdit Methods*/
  openImageEditor(item: any): void {
    this.dokInImageEditor = item;
    this.appSvc.Document.DokEdit.OpenModal(item, {Events: this.Events});
  }
  private refreshImage(image: any): void {
    image.imageVisible = false;
    // Bild nach einem kurzen Timeout wieder anzeigen, um es neu zu laden
    setTimeout(() => {
      image.imageVisible = true;
    }, 50);
  }
  private onImageEditFileComplete(dokID: string): void {
    this.refreshImagesOnPageByDokID(dokID);
    this.refreshImagesOnPicListByDokID(dokID);
  }
  private refreshImagesOnPageByDokID(dokID: string): void {
    this.pages.forEach(page => {
      ['top', 'left', 'right', 'bottom'].forEach(position => {
        page[position].forEach((image: { dokID: string; }) => {
          if (image.dokID === dokID) {
            // Wenn das Bild mit der gesuchten dokID gefunden wurde, aktualisiere es
            this.refreshImage(image);
          }
        });
      });
    });
  }
  private refreshImagesOnPicListByDokID(dokID: string): void {
    this.picbox.data.forEach((pic: {dokID: string}) => {
      if (pic.dokID === dokID) {
        this.refreshImage(pic);
      }
    });
  }

  private onImageEditComplete(newDokID: string, dokIDEditedImage: string, selectedPageEditedImage: number): void {
    this.replaceImageOnPageByDokID(newDokID, dokIDEditedImage, selectedPageEditedImage);
  }

  private replaceImageOnPageByDokID(newDokID: string, dokIDEditedImage: string, selectedPageEditedImage: number): void {
    this.pages.forEach(page => {
      ['top', 'left', 'right', 'bottom'].forEach(position => {
        page[position].forEach((image: { dokID: string; selectedPage: any }, index: number, array: any[]) => {
          if (image.dokID === dokIDEditedImage && (image.selectedPage === selectedPageEditedImage || !selectedPageEditedImage)) {
            array[index] = this.replaceImageWithEditedImage(newDokID);
          }
        });
      });
    });
  }

  private replaceImageWithEditedImage(newDokID: string): any {
    const indexOfEdited = this.picbox.delIncludedData.map((e: any) => e.dokID).indexOf(newDokID);
    return this.deepCopy(this.picbox.delIncludedData[indexOfEdited]);
  }
  private removeUsedDocumentFromPicbox(dokID: string): void {
    const index = this.picbox.data.findIndex(
      (item: any) => item.dokID === dokID
    );

    if (index !== -1) {
      this.picbox.data.splice(index, 1);
    }
  }
  private removeDeletedAndUsedData(documents: any[]): any[] {
    // Alle verwendeten dokIDs aus den Pages sammeln
    const usedDokIds = new Set<string>();

    if (this.pages && Array.isArray(this.pages)) {
      this.pages.forEach(page => {
        ['top', 'left', 'right', 'bottom'].forEach(position => {
          const items = page[position] || [];
          items.forEach((image: { dokID?: string }) => {
            if (image && image.dokID) {
              usedDokIds.add(image.dokID);
            }
          });
        });
      });
    }


    return documents.filter(doc =>
      doc.dokDEL !== true &&
      (!doc.dokID || !usedDokIds.has(doc.dokID))
    );
  }
}
